import { createSlice } from "@reduxjs/toolkit";
import { RequestStatus } from "../../model/ServiceRequestStatus.model";
import { postNebulaSupportAgentMessage, troubleshootWorkflow } from "../../services/NebulaSupportAgent/NebulaSupportAgent.api";

export interface NebulaSupportAgentState {
    threadId: string | null;
    content: { role: "user" | "system"; message: string }[];
    status: RequestStatus;
}

const initialState: NebulaSupportAgentState = {
    threadId: null,
    content: [],
    status: RequestStatus.idle,
};

export const NebulaSupportAgentSlice = createSlice({
    name: "NebulaSupportAgentSlice",
    initialState,
    reducers: {
        resetNebulaSupportAgent: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(postNebulaSupportAgentMessage.pending, (state) => {
                state.status = RequestStatus.loading;
            })
            .addCase(postNebulaSupportAgentMessage.fulfilled, (state, action) => {
                state.status = RequestStatus.succeeded;
                state.threadId = action.payload.threadId;
                state.content.push({
                    role: "system",
                    message: action.payload.response,
                });
            })
            .addCase(postNebulaSupportAgentMessage.rejected, (state, action) => {
                state.status = RequestStatus.failed;
                console.error("Error in NebulaSupportAgent:", action.error.message);
            })
            .addCase(troubleshootWorkflow.pending, (state) => {
                state.status = RequestStatus.loading;
            })
            .addCase(troubleshootWorkflow.fulfilled, (state, action) => {
                state.status = RequestStatus.succeeded;
                state.threadId = action.payload.threadId;
                state.content.push({
                    role: "system",
                    message: action.payload.response,
                });
            })
            .addCase(troubleshootWorkflow.rejected, (state, action) => {
                state.status = RequestStatus.failed;
                console.error("Error in NebulaSupportAgent troubleshoot:", action.error.message);
            });
    },
});

export const { resetNebulaSupportAgent } = NebulaSupportAgentSlice.actions;
export const NebulaSupportAgentReducer = NebulaSupportAgentSlice.reducer;
